import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { List, ListItem, VStack, Box, Icon } from '@chakra-ui/react'
import { SideBarProps } from '../types/layout';
import SvgIcon from '../components/ui/icons/SvgIcon';
import { menuItems } from '../utilities/dummy'
import { BsFillExclamationSquareFill } from 'react-icons/bs';

export default function SideBar({
    userId,
    applicationName,
    selected,
    collapsed,
    changeMenuState,
    onSetCurrentPage,
    ...props
}: SideBarProps) {
    // const collapseMenu = () => { changeMenuState(!collapsed) };
    const history = useHistory();
    const location = useLocation();
    const pathname = location.pathname
    const [isSubMenuOpen, setIsSubMenuOpen] = useState<Record<string, boolean>>({});
    const [currentSubMenuKey, setCurrentSubMenuKey] = useState<Record<string, boolean>>({});
    const [currentRouteKey, setCurrentRouteKey] = useState("overview")
    
    function setActiveMenu(key: string) {        
        setIsSubMenuOpen((prevState) => ({
            ...prevState,
            [key]: !prevState[key]
        }));
        setCurrentSubMenuKey((prevState) => ({
            ...prevState,
            [key]: !prevState[key]
        }))
    }

    function transformMenu() {
        return menuItems.map((menu) => {
            if (menu.subMenu) {
                return {
                    ...menu,
                    url: null,
                    subMenu: {
                        ...menu.subMenu,
                        items: menu.subMenu.items.map((sub) => ({ ...sub, url: `/dashboard/${userId}/${menu.key}/${sub.key}` }))
                    }
                }
            }

            return {
                ...menu,
                url: `/dashboard/${userId}/${menu?.key}`,
            }
        })
    }
    
    function handleLinkNavigation(label: string, url: string | null, subMenuKey?: string) {        
        if (!url) {
            setActiveMenu(subMenuKey!)
            onSetCurrentPage(label)
            return;

        };

        onSetCurrentPage(label);
        history.push(url);
    }

    useEffect(() => {
        if (pathname) {
            const splitPath = pathname.split("/");
            let selectedRoute = '';

            if (splitPath) {
                if (splitPath?.length === 5) {
                    selectedRoute = splitPath[4];
                    
                } else {
                    selectedRoute = splitPath[3];
                }
            }
            
            setCurrentRouteKey(selectedRoute);
        }
    }, [pathname])

    return (
       <Box className='sidebar-layout-wrapper'>
            <VStack spacing={4} className='sidebar-layout'>
                <Box className='sidebar'>
                    <List className='sidebar-list'>
                        {/* sidebar logo */}
                        <ListItem 
                            paddingBottom="2rem" 
                            paddingTop="2rem" 
                            className='sidebar-item flex align-items-center justify-content-between'
                        >
                            <Box className='flex align-items-center'                                         >
                                <Icon as={BsFillExclamationSquareFill} size='md' color='rgb(107, 114, 128)' marginRight={'2'} />
                                <span>
                                    {applicationName}   
                                </span>
                            </Box>
                        </ListItem>
                        {transformMenu().map((menu) => (
                            <>
                                <ListItem 
                                    key={menu.key} 
                                    className={
                                        `sidebar-item flex align-items-center justify-content-between 
                                        ${currentRouteKey === menu.key ? 'current' : ''}`
                                    }
                                    onClick={() => handleLinkNavigation(menu.label!, menu.url!, menu.subMenu?.key!)}
                                >
                                    <Box className='flex align-items-center'>
                                        <SvgIcon 
                                            type={menu.iconType} 
                                            viewBox="0 0 24 24" 
                                            height='16px'
                                            width='16px'
                                            color={currentRouteKey === menu.key ? 'rgb(59, 130, 246)' : 'rgb(107, 114, 128)'}
                                            styles={{ marginRight: '8px' }}
                                        />
                                        <span className={currentSubMenuKey[menu?.key] ? 'show' : ''}>
                                            {menu.label}
                                        </span>
                                    </Box>
                                    {menu.subMenu?.items?.length && (
                                        <span className={`menu-arrow pointer ${isSubMenuOpen && currentSubMenuKey[menu.subMenu.key] ? 'active' : ''}`} />
                                    )}
                                </ListItem>
                                {/* sub menu items */}
                                {menu.subMenu?.items?.length && (
                                    <List
                                        className={
                                            `sidebar-sub-menu
                                            ${isSubMenuOpen && currentSubMenuKey[menu?.subMenu?.key] ? 'show' : ''}
                                        `}
                                    >
                                            {menu?.subMenu?.items.map((sub) => (
                                                <ListItem 
                                                    className={`sidebar-item flex mb--0 align-items-center justify-content-between ${currentRouteKey === sub.key ? 'current' : ''}`}
                                                    key={sub.key}
                                                >
                                                    <span 
                                                        className={isSubMenuOpen && currentSubMenuKey[sub.key] ? 'active' : ''}
                                                        onClick={() => handleLinkNavigation(sub.label!, sub.url!, sub?.key)}
                                                    >
                                                        {sub.label}
                                                    </span>
                                                </ListItem>
                                            ))}
                                    </List>
                                )}
                            </>
                        ))}
                    </List>
                </Box>
            </VStack>
       </Box>
    )
}